module.exports = __webpack_public_path__ + "img/default3.a41f1f55.png";